const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalcIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "19px",
    height: "26px",
    viewBox: "0 0 19 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 20.009868 0.00120192 L 1.995066 0.00120192 C 0.894737 0.00120192 0.00164474 0.895132 0.00164474 1.998498 L 0.00164474 30.006611 C 0.00164474 31.104868 0.894737 31.998798 1.995066 31.998798 L 20.009868 31.998798 C 21.110197 31.998798 22.003289 31.104868 22.003289 30.006611 L 22.003289 1.998498 C 22.003289 0.895132 21.110197 0.00120192 20.009868 0.00120192 Z M 20.009868 0.00120192 ",
    transform: "matrix(0.791667,0,0,0.764706,0.791667,0.764706)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.898438 10.683594 L 3.605469 10.683594 C 3.363281 10.683594 3.167969 10.871094 3.167969 11.105469 L 3.167969 13.324219 C 3.167969 13.554688 3.363281 13.742188 3.605469 13.742188 L 5.898438 13.742188 C 6.140625 13.742188 6.335938 13.554688 6.335938 13.324219 L 6.335938 11.105469 C 6.335938 10.871094 6.140625 10.683594 5.898438 10.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.390625 10.699219 L 13.097656 10.699219 C 12.855469 10.699219 12.660156 10.890625 12.660156 11.121094 L 12.660156 13.339844 C 12.660156 13.570312 12.855469 13.757812 13.097656 13.757812 L 15.390625 13.757812 C 15.632812 13.757812 15.828125 13.570312 15.828125 13.339844 L 15.828125 11.121094 C 15.828125 10.890625 15.632812 10.699219 15.390625 10.699219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.652344 10.699219 L 8.359375 10.699219 C 8.117188 10.699219 7.921875 10.890625 7.921875 11.121094 L 7.921875 13.339844 C 7.921875 13.570312 8.117188 13.757812 8.359375 13.757812 L 10.652344 13.757812 C 10.894531 13.757812 11.089844 13.570312 11.089844 13.339844 L 11.089844 11.121094 C 11.089844 10.890625 10.894531 10.699219 10.652344 10.699219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.898438 15.273438 L 3.605469 15.273438 C 3.363281 15.273438 3.167969 15.460938 3.167969 15.695312 L 3.167969 17.910156 C 3.167969 18.144531 3.363281 18.332031 3.605469 18.332031 L 5.898438 18.332031 C 6.140625 18.332031 6.335938 18.144531 6.335938 17.910156 L 6.335938 15.695312 C 6.335938 15.460938 6.140625 15.273438 5.898438 15.273438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.390625 15.289062 L 13.097656 15.289062 C 12.855469 15.289062 12.660156 15.476562 12.660156 15.710938 L 12.660156 17.925781 C 12.660156 18.160156 12.855469 18.347656 13.097656 18.347656 L 15.390625 18.347656 C 15.632812 18.347656 15.828125 18.160156 15.828125 17.925781 L 15.828125 15.710938 C 15.828125 15.476562 15.632812 15.289062 15.390625 15.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.652344 15.289062 L 8.359375 15.289062 C 8.117188 15.289062 7.921875 15.476562 7.921875 15.710938 L 7.921875 17.925781 C 7.921875 18.160156 8.117188 18.347656 8.359375 18.347656 L 10.652344 18.347656 C 10.894531 18.347656 11.089844 18.160156 11.089844 17.925781 L 11.089844 15.710938 C 11.089844 15.476562 10.894531 15.289062 10.652344 15.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.90625 19.878906 L 3.613281 19.878906 C 3.371094 19.878906 3.175781 20.066406 3.175781 20.296875 L 3.175781 22.515625 C 3.175781 22.746094 3.371094 22.9375 3.613281 22.9375 L 5.90625 22.9375 C 6.148438 22.9375 6.34375 22.746094 6.34375 22.515625 L 6.34375 20.296875 C 6.34375 20.066406 6.148438 19.878906 5.90625 19.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.402344 19.894531 L 8.359375 19.894531 C 8.117188 19.894531 7.921875 20.082031 7.921875 20.3125 L 7.921875 22.53125 C 7.921875 22.761719 8.117188 22.953125 8.359375 22.953125 L 15.402344 22.953125 C 15.640625 22.953125 15.835938 22.761719 15.835938 22.53125 L 15.835938 20.3125 C 15.835938 20.082031 15.640625 19.894531 15.402344 19.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.402344 3.132812 L 3.613281 3.132812 C 3.371094 3.132812 3.175781 3.320312 3.175781 3.554688 L 3.191406 7.316406 C 3.191406 7.550781 3.386719 7.738281 3.628906 7.738281 L 15.417969 7.738281 C 15.65625 7.738281 15.851562 7.550781 15.851562 7.316406 L 15.835938 3.554688 C 15.835938 3.320312 15.640625 3.132812 15.402344 3.132812 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcIcon);
export default __webpack_public_path__ + "static/media/calc-icon.d18ff7de.svg";
export { ForwardRef as ReactComponent };